export default "__VITE_ASSET__Cp7a59gL__"